
// 빌드 : buildv commonmain
// ./build.sh commonmain

import 'es6-promise/auto'
import Vue from "vue";
import Axios from 'axios';

import Common from './components/ynadmin/common/common.js';
// import { Client, Message, Stomp } from '@stomp/stompjs';
import Pager from "./components/common/pagingUser.vue";
import mobile from "is-mobile";
import TotalSearchMykeyword from './components/common/total_search_mykeyword';

import {debounce} from "lodash";

// 빌드방법
// build commonmain
// (linux) time ./build.sh commonmain

const app = new Vue({
    el: '#messages',
    data: function() {
        return {
              message:''
              , detail:{}
              , isLog:false
              , title : ''
              , isTitle : false
              , isSend : false
              , isWrite:false
              , isWrite1:false
              , isWrite2:false
              , isMessage : false
              , mainName : '전체검색'
              , list :[]
              , listMessage:[]
              , listSubMessage:[]
              , stompClient :null
              , commonParams : {}
              , oneDepthModel:''
              , twoDepthModel:''
              , oneDepthLabel:''
              , twoDepthLabel:''
              , detailSend:{
                    uidKey : ''
                  , usrKey : ''
                  , receiveUsrKey:''
                  , nickName : ''
                  , receiveNickName:''
                  , message : ''
                  , isSend : ''
              }
              , detailWrite :{
                  uidKey : ''
                , usrKey : ''
                , receiveUsrKey:''
                , receiveNickName:''
                , nickName : ''
                , message : ''
                , isSend : ''
              }
            , detailView :{
                uidKey : ''
              , usrKey : ''
              , usrName : ''
              , message : ''
              , isSend : ''
            }
            , searchContent:''
        }
    },

    created: function(){

    },
    watch:{

    },
    mounted: function() {
       let _messageInit = $("#message").val();
       if(this.stompClient != null) this.getDisconnect();
       this.onLoadLoginUser();
       this.mainName  = "전체검색";
     //  this.getList();


    },
    beforeDestroy:function(){

    },
    updated:function(){

    }
    , methods: {
        onLoadLoginUser(){
            let param = {};
            let vm = this;
            Axios.post("/api/user/init/check", param).then(function(response) {

                vm.commonParams = response.data.commonParams;

                if(response.data.commonParams != null){
                 //   vm.getSocket();
                }else{
                   // vm.getDisconnect();
                }

            }).catch(function(ex) {
                console.log(ex);
            });
        }
        , getDisconnect:function(){
            if(this.stompClient != null){
                this.stompClient.disconnect();
                this.stompClient = null;
            }else{
                return;
            }
        }
        , getSocket : function(){
            let vm = this;
           /*  let _location = "wss://" +  window.location.host;
            let socket = new SockJS(_location + "/stompGreeting"); */
         /*    vm.stompClient = Stomp.over(socket);

            vm.stompClient.connect({}, function(frame){
                 vm.stompClient.subscribe(_location +'/topic/reply', function(message){
                   let _parse = JSON.parse(message.body);
                   if(vm.commonParams.accKey == _parse.usrKey ){
                        vm.showMessage(_parse);
                   }


                });

            }); */
        }
        , btnSearch:function(){
            location.href ="/api/share/search";
            this.getList();

        }
       ,  onClickWriteMessage(){
            this.isWrite = false;
            this.isWrite1 = false;
            this.isWrite2 = true;
            this.detailWrite.uidKey = this.detailView.uidKey;
            this.detailWrite.usrKey = this.detailView.usrKey;
            this.detailWrite.usrName = this.detailView.usrName;
            this.detailWrite.receiveUsrKey =  this.detailView.receiveUsrKey;
            this.detailWrite.nickName = this.detailView.nickName;
            this.detailWrite.receiveNickName = this.detailView.receiveNickName;

       }
        , writeMessage:function(){
            let vm = this;
            let _app = app1;
            /* let _location = "wss://" +  window.location.host;
            vm.stompClient.send(_location +'/youthnavis/stomp/in', {}, JSON.stringify(vm.detailWrite));
            vm.isWrite = false; */
            console.log(vm.detailWrite);
            vm.detailWrite.message = vm.searchContent;
            let param = { paramText :  JSON.stringify(vm.detailWrite) };

            Axios.post("/mynavi/user/program/message/create", param).then(function(response) {
                vm.isWrite = false;
                vm.isWrite1 = false;
                vm.isWrite2 = false;
                vm.searchContent = '';
                _app.fnGetMessageList(1);
            }).catch(function(ex) {
                console.log(ex);
            });


        }
        , sendMessage:function(){
            let vm = this;
            let _app = app1;
          //  let _location = "wss://" +  window.location.host;
          //  vm.stompClient.send(_location +'/youthnavis/stomp/in', {}, JSON.stringify(vm.detailSend));
           let param = { paramText :  JSON.stringify(vm.detailSend) };
           vm.detailWrite.message = vm.searchContent;
          Axios.post("/mynavi/user/program/message/create", param).then(function(response) {
            vm.isSend = false;
            vm.isWrite = true;

            vm.detailWrite.uidKey = Common.fnSetRandomUUID();
            vm.detailWrite.receiveUsrKey = vm.detailSend.usrKey;
            vm.detailWrite.receiveNickName = vm.detailSend.nickName;
            vm.detailWrite.usrKey =  vm.detailSend.receiveUsrKey;
            vm.detailWrite.nickName = vm.detailSend.receiveNickName;
            _app.fnGetMessageList(1);

          }).catch(function(ex) {
            console.log(ex);
          });

        }
        , fnOnClickSendMessage:function(){
            this.isSend = false;
            this.isWrite = true;

            this.detailWrite.uidKey = Common.fnSetRandomUUID();
            this.detailWrite.usrKey = this.detailSend.usrKey;
            this.detailWrite.receiveUsrKey = this.detailSend.receiveUsrKey;
            this.detailWrite.nickName = this.detailSend.nickName;
            this.detailWrite.receiveNickName = this.detailSend.receiveNickName;
            this.detailWrite.message = '';
            this.detailSend.message = '';
            this.fnGetMessageUpdate( this.detailSend.uidKey);
        }
        , fnOnClickCloseSend:function(){
            this.isSend = false;
            this.detailSend.usrKey = '';
            this.detailSend.nickName = '';
        }
        , fnOnClickCloseWrite:function(){
            this.isWrite = false;
            this.detailWrite.usrKey = '';
            this.detailWrite.nickName = '';
        }
        , fnOnClickCloseWriteOne:function(){
            this.isWrite1 = false;
            this.detailWrite.usrKey = '';
            this.detailWrite.nickName = '';
            this.searchCheckedCodes = [];
            this.searchCheckedValues = [];
        }
        , fnOnClickCloseWriteTwo:function(){
            this.isWrite2 = false;
            this.detailWrite.usrKey = '';
            this.detailWrite.nickName = '';
            this.searchCheckedCodes = [];
            this.searchCheckedValues = [];
        }
        , showMessage:function(body){
            let vm = this;
            vm.isSend = true;
           // vm.detailSend = body;
            vm.detailSend = {
                uidKey :body.uidKey
              , usrKey : body.receiveUsrKey
              , receiveUsrKey: body.usrKey
              , nickName : body.receiveNickName
              , receiveNickName: body.nickName
              , message : body.message
              , isSend : ''
          };
           // Stomp.send('/stomp/in', {}, JSON.stringify(vm.detailWrite));
        }
        , getList:function(){

            let vm = this;
            let _param = {title : vm.title};
            let param = {paramText : JSON.stringify(_param)};
            Axios.post("/api/admin/dashboard/allList", param).then(function(response) {
                vm.list = response.data.list;

            }).catch(function(ex) {
                console.log(ex);
            });

        }
        , fnGetMessageUpdate:function(uidKey){
            let vm = this;
            let _param = {uidKey : uidKey};
            let param = {paramText : JSON.stringify(_param)};
            Axios.post("/mynavi/user/program/message/update", param).then(function(response) {
            }).catch(function(ex) {
                console.log(ex);
            });

        }


    }
    ,filters: {

    }
});


Vue.component("pager", Pager);
const app1 = new Vue({
    el: '#messagePages',
    data: function() {
        return {
              message:''
              , detail:{}
              , isLog:false
              , title : ''
              , isTitle : false
              , isSend : false
              , isWrite : false
              , isMessage : false
              , mainName : '전체검색'
              , list :[]
              , allList : []
              , listMessage:[{title:'관리자', value:'xsr1'}, {title:'기관',value:'xsr2'}]
              , listSubMessage:[]
              , stompClient :null
              , commonParams : {}
              , receiveYnModel:'RECEIVE'
              , receiveYnLabel:'수신'
              , oneDepthModel:''
              , twoDepthModel:''
              , oneDepthLabel:'전체'
              , twoDepthLabel:'전체'
              , detailSend:{
                    uidKey : ''
                  , usrKey : ''
                  , message : ''
                  , isSend : ''
              }
              , detailWrite :{
                  uidKey : ''
                , usrKey : ''
                , message : ''
                , isSend : ''
              }
              , pager: {
                    model: {},
                    pageNo: 1,
                    pageNum:1,
                    totalSize: 0,
                    rowSize: 10,
                    blockSize: 10,
                    endSize:0,
                    list: [],
                    href:"#",
                    callBack: function (n) {
                      this.model.fnGetMessageList(n);
                    }
            }
        }
    },

    created: function(){

    },
    watch:{
        receiveYnModel : function(newval, oldval){
            this.receiveYnLabel = (newval == 'RECEIVE') ? '수신' : '발신';

        }
        , oneDepthModel : function(newval, oldval){
            this.oneDepthLabel = newval.title;
        }
        , twoDepthModel : function(newval, oldval){
            this.twoDepthLabel = newval.title;

        }
    },
    mounted: function() {
       let _messageInit = $("#message").val();
       this.onLoadLoginUser();

       if( _messageInit== 'MESSAGE'){
            this.mainName  = "쪽지보관함";
            this.isMessage = false;

       }

       $(".pop_wrapper").draggable();

    },
    beforeDestroy:function(){
    },
    updated:function(){

    }
    , methods: {
        onLoadLoginUser(){
            let param = {};
            let vm = this;
            Axios.post("/api/user/init/check", param).then(function(response) {
                // console.log(response);
                vm.commonParams = response.data.commonParams;
                if(response.data.commonParams != null){
                  //  vm.fnGetMessageOneDepth();
                    vm.fnMessageListGetSessionStorage();
                    vm.fnGetMessageList(vm.pager.pageNo);
                }

            }).catch(function(ex) {
                console.log(ex);
            });
        }
        , fnOnClickSendMessage:function(){
            app.isSend = true;
            app.detailSend.uidKey = Common.fnSetRandomUUID();
            app.detailSend.usrKey =  app.detailWrite.receiveUsrKey;
            app.detailSend.receiveUsrKey =  app.detailWrite.usrKey;
            app.detailSend.nickName = app.detailWrite.nickName;
        }
        , fnOnClickWriteMessage:function(){
            if(this.twoDepthLabel == ''){
                 alert("프로그램명과 이름을 선택해주세요");
                 return;
            }else{
                app.isWrite = true;
                app.detailWrite.uidKey = Common.fnSetRandomUUID();
                app.detailWrite.usrKey = this.twoDepthModel.usrKey;
                app.detailWrite.receiveUsrKey =  this.commonParams.accKey;
                app.detailWrite.nickName = this.twoDepthModel.title;
                app.detailWrite.receiveNickName = this.commonParams.loginUserNickName;
            }

        }
        , fnOnClickUserWriteMessages:function(item){
            app.isWrite = false;
            app.isWrite1 = true;
            app.isWrite2 = false;

            if(this.receiveYnModel == 'RECEIVE'){ // 수신함에서 답장하기
               app.detailView.uidKey = Common.fnSetRandomUUID();
               app.detailView.usrKey =  item.receiveUsrKey; // 보낸 사람 (나에게 온 쪽지이므로 수신자key 사용)
               app.detailView.receiveUsrKey = item.usrKey; // 받는 사람 (해당 쪽지 발신자 key 사용)
               app.detailView.usrName =   item.usrName;
               app.detailView.nickName =  item.usrName;
               app.detailView.receiveNickName = item.receiveName;
               app.detailView.receiveName =     item.receiveName;
               app.detailView.content = item.content;
            }else{ // 발신함에서 답장하기
                app.detailView.uidKey = Common.fnSetRandomUUID();
               app.detailView.usrKey = item.usrKey; // 보낸 사람
               app.detailView.receiveUsrKey =  item.receiveUsrKey; // 받는 사람
               app.detailView.usrName =  item.receiveName;
               app.detailView.nickName = item.receiveName;
               app.detailView.receiveNickName =item.usrName
               app.detailView.receiveName =    item.usrName
               app.detailView.content = item.content;
            }
            this.fnOnUseYn(item);
        }
        , fnOnClickUserWriteMessage:function(item){
            app.isWrite = true;
            app.detailWrite.uidKey = Common.fnSetRandomUUID();
            app.detailWrite.usrKey = this.commonParams.accKey;
            app.detailWrite.receiveUsrKey =  item.usrKey;
            app.detailWrite.nickName = item.usrName;
            app.detailWrite.receiveNickName = this.commonParams.loginUserNickName;
        }
        , fnOnUseYn(item){
            let vm = this;
            let param = { paramText :  JSON.stringify( {uidKey : item.uidKey }  ) };
            Axios.post("/mynavi/user/program/message/update", param).then(function(response) {
                vm.fnGetMessageList(1);

           }).catch(function(ex) {
               console.log(ex);
           });
       }

        , fnOnChangeMessageList:function(){
            this.fnGetMessageList(1);

        }
        , fnMessageListSetSessionStorage() {
            let vm = this;
            let backData = [{
                pageNo          : vm.pager.pageNo ,
                receiveYnModel  : vm.receiveYnModel ,
            }];

            sessionStorage.setItem('message.list',JSON.stringify(backData));
        }
        , fnMessageListGetSessionStorage() {
            let vm = this;
            let backData;
            if (sessionStorage.getItem('message.list') != null) {
              backData = JSON.parse(sessionStorage.getItem('message.list'));
              sessionStorage.removeItem('message.list');

              vm.pager.pageNo   = backData[0].pageNo;
              vm.receiveYnModel = backData[0].receiveYnModel;
            }
        }
        , fnGetMessageList:function(pageNumber){

            let vm = this;
            vm.pager.pageNo = pageNumber;
            let _param = {usrKey :  vm.commonParams.accKey, divide: vm.receiveYnModel, selecttext:null, startDateInfo : null, endDateInfo:null, text:null };
            let param = {
                  paramText : JSON.stringify(_param)
                , pageNo : vm.pager.pageNo
                , pageSize : vm.pager.rowSize
            };
            Axios.post("/mynavi/user/program/message/list", param).then(function(response) {

                vm.pager.totalSize = response.data.totalCount;
            	vm.pager.pageNum = (vm.pager.pageNo * vm.pager.rowSize) - vm.pager.rowSize;
                Pager.props = Pager.methods.createPager(vm.pager, vm, "list");
                vm.allList = response.data.listMessage;

                vm.fnMessageListSetSessionStorage();

            }).catch(function(ex) {
                console.log(ex);
            });

        }

        , fnGetMessageOneDepth:function(){

            let vm = this;
            let _param = {usrKey :  vm.commonParams.accKey};
            let param = {paramText : JSON.stringify(_param)};
            Axios.post("/mynavi/user/program/message/user", param).then(function(response) {

                vm.listMessage = response.data.listMessage;

            }).catch(function(ex) {
                console.log(ex);
            });

        }
        , fnGetMessageTwoDepth:function(item){
            let vm = this;
            let _param = {uidKey : item.uidKey};
            let param = {paramText : JSON.stringify(_param)};
            Axios.post("/mynavi/user/programsub/message/user", param).then(function(response) {
                console.log(response);
                vm.listSubMessage = response.data.listMessage;
            }).catch(function(ex) {
                console.log(ex);
            });

        }



    }
    ,filters: {

    }
});


const app2 = new Vue({
  el: '#vue_app_searchall',
  data: function () {
    return {
      title: '',
      mainName: '전체검색',
      list: [],
      isMobile: false,
      // 인기검색어
      popwordList: [],
      // 내가 찾은 검색어
      mywordList: [],
      // 자동 완성
      autowordList: [],
    }
  }
  , mounted: function () {
    console.log("mounted - totalSearchApp")
    this.isMobile = mobile();
    _vmTotalSearch = this
    // loadVmTotalSearch(this) // 외부 _vmTotalSearch 변수와 연동
  }
  , methods: {


    getSearch: function () {
      TotalSearchMykeyword.addMyKeyword(this.title, 10) // 내가 찾은 검색어 추가

      // if (this.isMobile) { // TODO CHECK :: 통합검색 모바일 대기중이므로 기존 화면 사용
      // location.href = "/customer/expinfo/share/search?title=" + this.title; // 기존 통합검색
      // } else if (location.pathname.indexOf('/customer/expinfo/share/search_exp') > -1) {
      //   location.href = "/customer/expinfo/share/search_exp?title=" + this.title; // 검색엔진 통합검색 페이징
      // } else {
        location.href = "/customer/expinfo/share/search2?title=" + encodeURI(this.title); // 검색엔진 통합검색
      // }
    },
    doSearch: function(word) {
      this.title = word
      this.getSearch()
    },

    /** 검색영역 데이터 로딩 */
    loadSearchLayerData: async function() {
      this.loadPopwordList().then() // 인기검색어 로딩
      this.myKeywordLoad(); // 최근 검색어 로딩
    },
    /* 인기검색어 로딩 */
    loadPopwordList: async function() {
      // 조회범위 : D 일 W 주 M 월
      const ret = await Axios.get("/search/popword.do", {params: {range: 'M'} })
      // console.log("popwordList = ", ret.data?.Data?.Query) // content : "검색광고" count : 1 id : 2 updown : "U"
      this.popwordList = ret.data?.Data?.Query ?? []
    },
    /*최근 검색어 로딩*/
    myKeywordLoad: function () {
      this.mywordList = TotalSearchMykeyword.getMyKeywordAll()
    },
    /*최근 검색어 하나 삭제*/
    myKeywordDel: function(word) {
      TotalSearchMykeyword.removeMyKeyword(word)
      this.myKeywordLoad();
    },
    /*최근 검색어 전체 삭제*/
    myKeywordRemoveAll: function() {
      TotalSearchMykeyword.removeAllMyKeyword()
      this.myKeywordLoad();
    },
    /* 자동완성 */
    onChangeTitle: debounce(async function(n) {
      // console.log("***" + n)
      // http://localhost:8080/search/ark.do?query=캠프
      // console.log("쿼리 = " + n)
      const ret = await Axios.get("/search/arkSimple.do", {params: {query: n}})
      // console.log(ret)
      this.autowordList = ret.data?.list ?? []
      // console.log("this.autowordList = ", this.autowordList)
      // "hkeyword": "<font style='font-size:13px'><font style='color:#CC6633'>1</font>2월</font>",
      // "keyword": "12월",
      // "count": 30,
      // "type": 1,
      // "linkname": "",
      // "linkurl": ""
    },300),
  },
  watch:{
    title(n) { this.onChangeTitle(n) },
  },
  filters: {}
});

const app3 = new Vue({
    el: '#searchResult',
    data: function() {
        return {
                title : ''
              , mainName : '전체검색'
              , list :[]
        }
    }
    , mounted: function() {
        let vm = this;
        try{
           //pageLoad(this);
        }catch(e){

        }
     }
    , methods: {


          fnGetDetail(item){
            console.log(item);
            if(item == null){
                return "--";
            }else if(item.code == "BRDNVYTHNV00600"){
                location.href = "/customer/expinfo/detailReview?uidKey="+item.uidKey;
            }else if(item.code == "PRGMNVYTHNV01000"){
                location.href = "/customer/expinfo/detailExpinfo?uidKey="+item.uidKey+"&tab=3";
            }else if(item.code == "PRGMNVYTHNV0210"){
                location.href = "/customer/expinfo/detailExpinfo?uidKey="+item.uidKey+"&tab=3";
            }else if(item.code == "PRGMNVYTHNV0220"){
                location.href = "/customer/expinfo/detailExpinfo?uidKey="+item.uidKey+"&tab=3";

            }else if(item.code == "BRDNVYTHNV01100"){
                location.href = "/customer/afterschool/program/detail?uidKey="+item.uidKey+"&tab=3";
            }else if(item.code == "BRDNVYTHNV01200"){
                location.href = "/customer/afterschool/connect?tab=1&uidKey="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV00920"){
                location.href = "/customer/pare/detailReview?uid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV00900"){
                location.href = "/customer/pare/momsBoardDetail?uid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV00910"){
                location.href = "/customer/pare/momsBoardDetail?uid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV00930"){
                location.href = "/customer/pare/momsBoardDetail?uid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV00500"){
                location.href = "/customer/realinfo/content/detail?uidKey="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV02600"){
                location.href = "/customer/homebase/liveFestivalVodDetail?paramUid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV00000" ){
                location.href = "/customer/youth/youthNewsDetail?paramUid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV00800"){
                location.href = "/customer/voice/voiceDetail?paramUid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV02300" ){
                location.href = "/customer/homebase/galleryDetail?paramUid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV02000" ){
                location.href = "/customer/homebase/contentsDetail?paramUid="+item.uidKey;
            }else if(item.code == "HBTABCATENV000120" ){
                location.href = "/customer/homebase/communityDetail?paramUid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV02400" ){
                location.href = "/customer/homebase/contentsDetail?paramUid="+item.uidKey;
            }else if(item.code == "BRDNVYTHNV02100" ){ // 동아리 클릭
                location.href = "/customer/homebase/homeBaseDetail?paramUid="+item.uidKey;
            }else{
                swal({
                    text : "해당페이지로 이동이 불가능합니다.",
                    closeOnClickOutside : false,
                    // icon : this.fnOnLoadSwalImageData("error"),
                    buttons : {
                        confirm : {
                            text : "확인",
                            value : true,
                            visible : true
                        },
                        cancel : {
                            text : "취소",
                            value : false,
                            visible : false
                        }
                    }
                })
            }

        }
       , fnOnLoadSwalImageData:function(value){
            let _icon = "/design/common/images/sub/img_alert_"+value+".png";
            return _icon;
        }

    }
    ,filters: {

    }
});


